import PageLayout from "../components/site/PageLayout";
import { SectionHeading } from "../components/site/SectionHeading";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useContent } from "../lib/content";

const Faq = () => {
  const { content } = useContent();
  return (
    <PageLayout title="FAQ">
      <section className="relative pt-16 pb-10 overflow-hidden">
        <div className="ambient" aria-hidden />
        <div className="ambient-grid" aria-hidden />
        <div className="container-tt">
          <SectionHeading eyebrow="FAQ" title="Frequently asked questions." description="Everything you need to know about TechTies. Still curious? Reach us anytime via Contact." />
        </div>
      </section>
      <section className="pb-24">
        <div className="container-tt max-w-3xl">
          <div className="card-surface px-6 md:px-8">
            <Accordion type="single" collapsible data-testid="faq-list">
              {content.faqs.map((f, i) => (
                <AccordionItem key={i} value={`f-${i}`} className={i === content.faqs.length - 1 ? "border-b-0" : ""}>
                  <AccordionTrigger className="text-left text-lg py-6 font-display font-medium text-stone hover:no-underline hover:text-skyDark">{f.q}</AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default Faq;
